import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';

const tokenKey = 'Authorization';

// Auth-token storage — platform-aware.
//
// Web: HttpOnly cookie set by the server, JS-inaccessible. No client-side
// storage. The cookie travels automatically on same-site XHRs (SPA at
// *.scconnect.nl, API at api.scconnect.nl / api-staging.scconnect.nl —
// sibling subdomains of the same registrable domain) when axios is
// configured with `withCredentials: true`. All three functions below are
// no-ops on web — the server handles the cookie lifecycle on login/logout.
// This closes the XSS-token-exfiltration vector (Week 5 attempted but the
// cross-site cookie was blocked; Week 8 unblocked it via the subdomain
// consolidation under scconnect.nl).
//
// Mobile (Capacitor): Capacitor Preferences (secure keychain-backed
// storage) + x-auth-token header. Mobile hits *.azurewebsites.net directly
// — it's not subject to browser cookie rules and doesn't need the
// subdomain pattern. The server detects this via the request hostname
// and skips Set-Cookie for those requests.
const getAuthToken = async (): Promise<string | null> => {
  if (Capacitor.isNativePlatform()) {
    const { value } = await Preferences.get({ key: tokenKey });
    return value;
  }
  return null;
};

export const setAuthToken = async (token: string): Promise<void> => {
  if (Capacitor.isNativePlatform()) {
    await Preferences.set({ key: tokenKey, value: token });
  }
};

export const clearAuthToken = async (): Promise<void> => {
  if (Capacitor.isNativePlatform()) {
    await Preferences.remove({ key: tokenKey });
  }
};

export default getAuthToken;
